import { useTranslation } from "react-i18next";
import { ModalHeader } from "datastake-daf/dist/components";

export default function Header() {
  const { t } = useTranslation();
  return (
    <ModalHeader
      title={t("KYC Checks")}
    />
  )
}
